import { useContext } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import ProtectedLayout from "./layouts/ProtectedLayout";
import useAuthApi from "./api/useAuth.api";
import {
  DASHBOARD,
  LOGIN,
  ADD_LEADS,
  TASKS_STATUS,
  ITINERARY_DETAILS,
  QUOTATION_DETAILS,
  PAYMENT_PAGE,
  PAYMENT_STATUS,
  ALL_BOOKINGS,
  EMAIL_LOGS,
} from "./utils/ConstantLinks";
import Snackbar from "./components/Snackbar";
import { AuthProvider } from "./context/auth.context";
import SnackbarContext from "./context/snackbar.context";
import UserLayout from "./layouts/UserLayout";
import LoginForm from "./pages/LoginForm/LoginForm";
import Dashboard from "./pages/Dashboard/Dashboard";
import AddLeads from "./pages/AddLeads";
import NotFound from "./pages/404/NotFound";
import PublicDetailPage from "./pages/PublicDetailsPage";
import PublicLayout from "./layouts/PublicLayout";
import PublicPaymentPage from "./pages/PublicPaymentPage";
import PaymentStatusPage from "./pages/PaymentStatusPage";
import TasksStatus from "./pages/TasksStatus/TasksStatus";
import AllBookings from "./pages/AllBookings/AllBookings";
import EmailLogsPage from "./pages/PublicEmailLogs/EmailLogsPage";

function App() {
  const snackbarCtx = useContext(SnackbarContext);
  const authHookData = useAuthApi({ snackbarCtx });

  return (
    <BrowserRouter>
      <AuthProvider data={{ ...authHookData }}>
        {snackbarCtx?.data?.visible && <Snackbar />}
        <Routes>
          <Route element={<UserLayout />}>
            <Route path={LOGIN} element={<LoginForm />} />
          </Route>
          <Route element={<ProtectedLayout />}>
            <Route path={DASHBOARD} element={<Dashboard />} />
            <Route path={ADD_LEADS} element={<AddLeads />} />
            <Route path={ALL_BOOKINGS} element={<AllBookings />} />
            <Route path={TASKS_STATUS} element={<TasksStatus />} />
          </Route>
          <Route element={<PublicLayout />}>
            <Route path={ITINERARY_DETAILS} element={<PublicDetailPage />} />
            <Route path={QUOTATION_DETAILS} element={<PublicDetailPage />} />
            <Route path={PAYMENT_PAGE} element={<PublicPaymentPage />} />
            <Route path={PAYMENT_STATUS} element={<PaymentStatusPage />} />
            <Route path={EMAIL_LOGS} element={<EmailLogsPage />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
